import { useCollection } from '@cloudscape-design/collection-hooks';
import { Button, ButtonDropdown, FormField, Input, Link, Pagination, SpaceBetween, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from "@cloudscape-design/components/header";
import { mdiArrowCollapseUp, mdiArrowSplitHorizontal, mdiArrowSplitVertical, mdiMonitorScreenshot, mdiMoveResize, mdiReload } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';

export const MarketingMediasPage = () => {
    const [media, setMedia] = useState<any>(null)

    const { navigate } = useRouter();
    const { parameters, menu, idAirport } = useGlobalState();
    const [medias, setMedias] = useState<any[]>([])
    const [videoUrl, setVideoUrl] = useState<string>("");


    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const filtered = useMemo(() => {

        if (!medias) return [];
        if (!medias.length) return [];
        if (filterValue.trim().length < 2) return medias;
        setCurrentPageIndex(1);
        const searchWords = filterValue.toLowerCase().trim().split(/\s+/);
        return medias.filter((item: any) => {
            const searchableText = `${item.fileName} 
            ${item.idMediaSet?.toString() || ''} 
            ${item.isUsed === null ? 'used=0' : 'used=1'} 
            ${item.fs3?.toString() !== "" ? "S3" : item.fp2?.toString() !== "" ? "FP2" : item.fp1?.toString() !== "" ? "FP1" : "NONE"} 
            ${JSON.stringify(item.metadata)}`.toLowerCase();
            return searchWords.every(word => searchableText.includes(word));
        });
    }, [medias, filterValue]);
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    const handleMoveToS3 = async (idMediaSet: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/medias/movetos3',
                },
                body: JSON.stringify({
                    idMediaSet: idMediaSet,
                    orderBy: "fileName",
                    order: "ASC"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (dataWeb.medias) {
                    setMedias(dataWeb.medias);
                }
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    }
    const handleUpdateMetaData = async (idMediaSet: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/medias/updatemetadata',
                },
                body: JSON.stringify({
                    idMediaSet: idMediaSet,
                    orderBy: "fileName",
                    order: "ASC"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (dataWeb.medias) {
                    setMedias(dataWeb.medias);
                }

            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    }


    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetPrograms();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleGetPrograms = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/medias/list',
                },
                body: JSON.stringify({
                    orderBy: "fileName",
                    order: "ASC"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {


                if (dataWeb.medias) {
                    setMedias(dataWeb.medias);
                } else {
                    setMedias([]);
                }
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (parameters.date !== "") {
            handleGetPrograms();
        }

    }, [parameters.date]);
    useEffect(() => {

    }, []);
    const columnDefinitions = useMemo(() => [
        {
            id: "id",
            cell: (e: any) => <FormField label={e.idMediaSet}>{e.isUsed !== null ? <Link><Icon path={mdiMonitorScreenshot} size={0.75} /></Link> : null}</FormField>,
            header: "ID",
            width: 100
        },
        {
            id: "description",
            cell: (e: any) => <FormField label={e.fileName || "Sin nombre"}>
                <SpaceBetween direction="horizontal" size="xs">
                    <Icon path={mdiMoveResize} size={1} />
                    {e?.metadata?.aspect}
                    <Icon path={mdiArrowSplitVertical} size={1} />
                    {e?.metadata?.width}px
                    <Icon path={mdiArrowSplitHorizontal} size={1} />
                    {e?.metadata?.height}px

                </SpaceBetween>

            </FormField>,
            header: "Archivo",
            width: 300,
            sortingField: "fileName"
        },
        {
            id: "weight",
            cell: (e: any) => <FormField label={`${e?.metadata?.size}KB`}>{e?.metadata?.duration} sec</FormField>,
            width: 100,
            header: "Tamaño",
            sortingComparator: (a: any, b: any) => {
                const sizeA = Number(a.metadata?.size) || 0;
                const sizeB = Number(b.metadata?.size) || 0;
                return sizeA - sizeB;
            },
        },
        {
            id: "source",
            cell: (e: any) => <>{e?.fs3 !== "" ? `S3` : `Local ${e?.fp2 !== "" ? "FP2" : e?.fp1 !== "" ? "FP1" : "NE"}`}</>,
            header: "Fuente",
            width: 100
        },
        {
            id: "preview",
            cell: (e: any) => (<ButtonDropdown
                onItemClick={(ev) => {
                    if (ev.detail.id == "metadata") {
                        handleUpdateMetaData(e.idMediaSet);
                    }
                    if (ev.detail.id == "fp2s3") {
                        handleMoveToS3(e.idMediaSet);
                    }
                }}
                expandToViewport
                items={[
                    { id: "preview", text: "Previsualizar" },
                    { id: "metadata", text: "Extraer metadatos", disabled: (e?.fs3 === "") },
                    { id: "fp2s3", text: "Mover a S3", disabled: (!((e.fp1 != "" || e.fp2 != "") && e.fs3 == "")) },
                ]}
                ariaLabel="Control instance"
                variant="icon"
            />),
            header: "",
            width: 50
        }
    ], []);

    const { items, collectionProps } = useCollection(
        paginated,
        {
            sorting: {
                defaultState: {
                    sortingColumn: columnDefinitions[0],
                    isDescending: false
                }
            },
            filtering: {
                empty: "No se encontraron medios",
                noMatch: "No hay coincidencias"
            },
        }
    );
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Button variant="normal" onClick={() => window.location.hash = '#marketing/media.upload'}><Icon path={mdiArrowCollapseUp} size={1} /></Button>}>Stock multimedia {`(${filtered.length}/${medias.length})`}</Header>
                    <Table
                        {...collectionProps}
                        trackBy="idMediaSet"
                        items={items ?? []}
                        columnDefinitions={columnDefinitions}
                        wrapLines={false}
                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > parameters.pageSize && (

                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        variant='embedded'
                        stickyHeader
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Palabra(s) clave(s)">
                                    <Input value={filterValue} placeholder="Buscar programas" onChange={e => setFilterValue(e.detail.value)}

                                    />
                                </FormField>
                                <FormField label="&nbsp;">
                                    <Button variant="primary" onClick={() => {
                                        handleGetPrograms();
                                    }}><Icon path={mdiReload} size={1} /></Button>
                                </FormField>
                            </SpaceBetween>
                        }
                    />

                </SpaceBetween>
            }
        />
    )
};
